import { render, staticRenderFns } from "./interest.vue?vue&type=template&id=feadd8fe"
import script from "./interest.vue?vue&type=script&lang=ts"
export * from "./interest.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports